// TICKET-01482: journal text templates ("Maler") were inserted verbatim, so
// bracket codes like [animal] and [weight] ended up as literal text in the
// journal. These helpers substitute the same token family as the
// booking/notification SMS templates at insert time.
//
// Rules:
// - Only tokens with a non-empty value are replaced; an unfilled token (e.g.
//   [weight] before the vet has weighed the animal) is left as-is so it is
//   visible that something still needs to be filled in by hand.
// - Unknown tokens are never touched.
// - Pure functions only: never mutate the input objects.

function hasValue(value) {
    if (value === null || value === undefined) {
        return false;
    }
    return `${value}`.trim() !== '';
}

// Escape a token key for use inside a regular expression. Keys are our own
// (animal, weight, ...) but keep this safe for any future key.
function escapeRegExp(string) {
    return `${string}`.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function applyTemplateFields(body, values = {}) {
    if (typeof body !== 'string') {
        return '';
    }
    let result = body;
    Object.keys(values).forEach((key) => {
        const value = values[key];
        if (!hasValue(value)) {
            return;
        }
        const token = new RegExp(`\\[${escapeRegExp(key)}\\]`, 'g');
        result = result.replace(token, `${value}`);
    });
    return result;
}

// Build the token values for a journal context. Every supported key is always
// present (so callers can list the available codes); keys without a usable
// value are undefined and applyTemplateFields leaves their token untouched.
// weight comes from the journal's own weight field ONLY (today's typed
// weight) — never a stale last-recorded weight, for the same trust reasons as
// TICKET-01048. Numeric fields are cleared to 0 in this app, so 0 counts as
// "no weight".
export function buildJournalTemplateFields({ journal, animal, visitor, customer } = {}) {
    const weight = journal ? journal.weight : undefined;
    return {
        animal: animal && hasValue(animal.name) ? animal.name : undefined,
        weight: hasValue(weight) && parseFloat(weight) > 0 ? weight : undefined,
        name: visitor && hasValue(visitor.firstname) ? visitor.firstname : undefined,
        clinic: customer && hasValue(customer.name) ? customer.name : undefined,
        clinicPhone: customer && hasValue(customer.phone) ? customer.phone : undefined,
        clinicEmail: customer && hasValue(customer.email) ? customer.email : undefined,
    };
}

export default applyTemplateFields;
